export default {
  path: '/auth',
  name: 'ShuangLiuBind',
  meta: {
    title: '双流登录',
  },
  component: () => import('_views/shuangLiuBind/index.vue'),
}
